import { __extends } from "tslib";
import { CreateStreamInput } from "../models/models_0";
import { deserializeAws_json1_1CreateStreamCommand, serializeAws_json1_1CreateStreamCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var CreateStreamCommand = /** @class */ (function (_super) {
    __extends(CreateStreamCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CreateStreamCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    CreateStreamCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "KinesisClient";
        var commandName = "CreateStreamCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: CreateStreamInput.filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CreateStreamCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1CreateStreamCommand(input, context);
    };
    CreateStreamCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1CreateStreamCommand(output, context);
    };
    return CreateStreamCommand;
}($Command));
export { CreateStreamCommand };
//# sourceMappingURL=CreateStreamCommand.js.map